import { SelectionToggleStatus } from "@/app/nft/sell/selection/nft-selection-toggle.reatom"
import type { NftSearchItem } from "@anaconda/core/nft/search/types"
import { Skeleton } from "@rarible_int/anaconda_ui_components"
import { Cell, HeaderCell } from "./cells"
import { MatchedOffer, MatchedOfferSkeleton } from "./matched-offer"
import { NftMiniature, NftMiniatureSkeleton } from "./nft-miniature"

interface Column {
  Header: React.ComponentType
  Content: React.ComponentType<NftSearchItem>
  Skeleton: React.ComponentType
}

export const COLUMNS: Column[] = [
  {
    Header: () => <HeaderCell className="w-[40px] text-right" />,
    Content: (nft) => (
      <Cell>
        <SelectionToggleStatus nftId={nft.id} />
      </Cell>
    ),
    Skeleton: () => <Skeleton className="h-6 w-6 rounded-full" />,
  },
  {
    Header: () => <HeaderCell className="w-[200px] text-right" />,
    Content: (nft) => (
      <Cell>
        <NftMiniature nft={nft} />
      </Cell>
    ),
    Skeleton: () => <NftMiniatureSkeleton />,
  },
  {
    Header: () => <HeaderCell className="text-right" />,
    Content: (nft) => (
      <Cell>
        <div className="flex justify-end">
          <MatchedOffer nft={nft.id} />
        </div>
      </Cell>
    ),
    Skeleton: () => <MatchedOfferSkeleton />,
  },
]
